import React from 'react';

import { ComingSoonMessage } from '../../components/PageLayout';

const ExamsPage = () => (
  <ComingSoonMessage dueDate="Apr 2024" />
);
export default ExamsPage;
